exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.login .login-content[data-v-66a49aee] {\n    color:#525252\n}\n.login.login-v2 .form-control[data-v-66a49aee] {\n    background: rgb(255, 255, 255);\n    border: 1px solid #b9b9b9;\n    color:black;\n    font-size:14px;\n    height: 40px;\n}\n", ""]);

// exports
